export function parseDecimalNumberInput(value: string): number {
  const normalizedValue = value.trim().replace(",", ".");

  if (normalizedValue.length === 0) {
    return Number.NaN;
  }

  return Number(normalizedValue);
}

export function formatNumberInput(value?: number | null): string {
  return typeof value === "number" ? String(value) : "";
}

export function isFiniteNumber(value: number | null | undefined): value is number {
  return typeof value === "number" && Number.isFinite(value);
}

export function roundToDecimalPlaces(value: number, decimalPlaces = 4): number {
  return Number.parseFloat(value.toFixed(decimalPlaces));
}
